module.exports = __webpack_public_path__ + "2f3e037b0833c0c91d74833da552bf3f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-12.png
// module id = 2242
// module chunks = 0